import React, { createContext, useState, useContext, useCallback } from 'react';

const LoadingContext = createContext({
  loading: false,
  setLoading: () => {},
  apiLoading: false,
  setApiLoading: () => {},
  loadingMessage: '',
  setLoadingMessage: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(true); // Page loading
  const [apiLoading, setApiLoading] = useState(false); // API loading
  const [loadingMessage, setLoadingMessage] = useState('Loading...');

  // Simple API loading functions
  const showApiLoader = useCallback((message = 'Loading data...') => {
    setLoadingMessage(message);
    setApiLoading(true);
  }, []);

  const hideApiLoader = useCallback(() => {
    setApiLoading(false);
    setLoadingMessage('');
  }, []);

  const contextValue = {
    loading,
    setLoading,
    apiLoading,
    setApiLoading,
    loadingMessage,
    setLoadingMessage,
    showApiLoader,
    hideApiLoader,
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
};

// Simple hook for API loading
export const useApiLoading = () => {
  const { showApiLoader, hideApiLoader } = useLoading();
  return { showApiLoader, hideApiLoader };
};
